<div *ngIf="isAggregatedActive" class="common-wrapper">
  <div class="output-summary-container common-width">
    <div class="wrapper">
      <div class="filters-wrapper">
        <div
          class="details-wrapper"
          style="display: grid; align-items: center; margin-bottom: 22px"
        >
          <div style="display: flex; gap: 20px">
            <div class="selectedBaseScenario" style="margin-top: 4px">
              <span> Selected Base Scenario : </span>
              <span style="font-weight: 500">
                {{ baseScenarioName }}
              </span>
            </div>
            <app-filter-group
              style="width: 500px"
              (selectionChanged)="scenarioFilterHandle($event)"
              [newFiltersOptions]="scenarioFilterOptions"
              [filters]="scenarioFilters"
              [defaultFilterOption]="scenarioDefaultFilterOption"
              [addLeftToRightDisableFunctionality]="
                addLeftToRightDisableFunctionality
              "
              [resetOtherFiltersBasedCurrentSelection]="
                resetOtherFiltersBasedCurrentSelection
              "
            ></app-filter-group>
          </div>
          <app-base-scenario-details></app-base-scenario-details>

          <div
            *ngIf="hideFilters"
            style="
              margin-top: auto;
              margin-bottom: auto;
              justify-self: flex-end;
            "
          >
            <mat-progress-spinner
              color="primary"
              diameter="20"
              mode="indeterminate"
              style="margin-top: 5px; margin-left: -3px"
            >
            </mat-progress-spinner>
          </div>
        </div>
        <div style="display: grid; margin-top: 1rem">
          <app-filter-group
            (selectionChanged)="filterHandle($event)"
            [newFiltersOptions]="newGroupFilters"
            [filters]="outputFilters"
            [defaultFilterOption]="defaultFilterOption"
            [addLeftToRightDisableFunctionality]="
              addLeftToRightDisableFunctionality
            "
            [resetOtherFiltersBasedCurrentSelection]="
              resetOtherFiltersBasedCurrentSelection
            "
          ></app-filter-group>
          <div style="display: flex; justify-content: flex-end; gap: 16px">
            <button mat-button (click)="resetFilters()">
              <!-- [ngStyle]="{ visibility: isClearActive ? 'visible' : 'hidden' }" -->
              Reset
            </button>
            <button
              mat-raised-button
              style="
                width: 80px;
                height: 36px;
                text-align: center;
                justify-self: flex-end;
                align-self: end;
              "
              color="primary"
              [disabled]="filterLoader"
              (click)="applyFilterChange()"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
      <div class="active-filters">
        <div class="filter-container">
          <span class="new-header">View By</span>
          <mat-chip-listbox style="display: flex" aria-label="View By">
            <mat-chip-option
              *ngFor="let chip of dataTypechips; let i = index"
              [selected]="chip.selected"
              (click)="viewByDataType(i)"
              [style.pointer-events]="chip.selected ? 'none' : 'auto'"
              style="cursor: pointer; border: 1px solid lightgrey"
              >{{ chip.name }}</mat-chip-option
            >
          </mat-chip-listbox>
        </div>
        <div class="filter-container">
          <span class="new-header">View By</span>
          <mat-chip-listbox style="display: flex" aria-label="View By">
            <mat-chip-option
              *ngFor="let chip of chips; let i = index"
              [selected]="chip.selected"
              (click)="viewBy(i)"
              [style.pointer-events]="chip.selected ? 'none' : 'auto'"
              style="cursor: pointer; border: 1px solid lightgrey"
              >{{ chip.name }}</mat-chip-option
            >
          </mat-chip-listbox>
        </div>
      </div>
    </div>
    <div class="charts-wrapper">
      <!-- [ngStyle]="{
        'grid-template-columns': layoutChange ? '1fr 1fr' : '1fr 1.4fr 1fr'
      }" -->
      <!-- vc margin chart  -->
      <div class="common-chart profit-chart">
        <!-- [ngClass]="{
          secondChartPosition: layoutChange
        }" -->
        <div class="header">
          <img
            src="../../../assets/IMP PVP Tool Icons/Group 512775.svg"
            alt=""
          />
          <span class="new-header"> Margin </span>
        </div>
        <div class="profit-chart">
          <ng-container *ngIf="!dataLoader">
            <highcharts-chart
              [Highcharts]="highcharts"
              [options]="profitChartConfig"
              [(update)]="profitChartConfig.update"
              #grossRevenueRef
              [callbackFunction]="grossRevenueChartCallback"
              style="width: 100%; height: 400px; display: block"
            >
              <!-- style="width: 100%; display: block; height: 270px" -->
              <!-- [ngStyle]="{
              height: layoutChange ? '350px' : '250px'
            }" -->
            </highcharts-chart>
          </ng-container>

          <mat-card
            *ngIf="dataLoader"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              height: 400px;
            "
            class="mat-elevation-z0"
          >
            <mat-progress-spinner
              diameter="70"
              color="primary"
              mode="indeterminate"
            >
            </mat-progress-spinner>
            <h4 style="font-weight: bold; margin-top: 10px">Loading...</h4>
          </mat-card>
        </div>
      </div>
      <!-- volume chart  -->
      <div class="common-chart volume-chart">
        <div class="header">
          <img
            src="../../../assets/IMP PVP Tool Icons/Group 512775.svg"
            alt=""
          />
          <span class="new-header"> Volume </span>
        </div>
        <ng-container *ngIf="!dataLoader">
          <highcharts-chart
            [Highcharts]="highcharts"
            #volumeChart
            [options]="volumeChartConfig"
            [(update)]="volumeChartConfig.update"
            update
            [callbackFunction]="chartCallback"
            style="width: 100%; height: 400px; display: block"
          >
          </highcharts-chart>
        </ng-container>
        <mat-card
          *ngIf="dataLoader"
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            height: 400px;
          "
          class="mat-elevation-z0"
        >
          <mat-progress-spinner
            diameter="70"
            color="primary"
            mode="indeterminate"
          >
          </mat-progress-spinner>
          <h4 style="font-weight: bold; margin-top: 10px">Loading...</h4>
        </mat-card>
      </div>
      <!-- revenue chart  -->
      <div class="common-chart revenue-chart">
        <!-- [ngClass]="{
          secondChartPosition: layoutChange
        }" -->
        <div class="header">
          <img
            src="../../../assets/IMP PVP Tool Icons/Group 512775.svg"
            alt=""
          />
          <span class="new-header">Market Share</span>
        </div>
        <div class="revenue-chart">
          <ng-container *ngIf="!dataLoader">
            <highcharts-chart
              [Highcharts]="highcharts"
              [options]="revenueChartConfig"
              [(update)]="revenueChartConfig.update"
              #revenueChart
              [callbackFunction]="revenueChartCallback"
              style="width: 100%; height: 400px; display: block"
            >
              <!-- style="width: 100%; display: block; height: 270px" -->
              <!-- [ngStyle]="{
                height: layoutChange ? '350px' : '250px'
              }" -->
            </highcharts-chart>
          </ng-container>

          <mat-card
            *ngIf="dataLoader"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              height: 400px;
            "
            class="mat-elevation-z0"
          >
            <mat-progress-spinner
              diameter="70"
              color="primary"
              mode="indeterminate"
            >
            </mat-progress-spinner>
            <h4 style="font-weight: bold; margin-top: 10px">Loading...</h4>
          </mat-card>
        </div>
      </div>
    </div>

    <!-- Output Summary -->

    <div class="output-wrapper">
      <div
        class="common-chart base-value-and-transaction-chart"
        style="margin-bottom: 40px"
      >
        <div class="header">
          <img
            src="../../../assets/IMP PVP Tool Icons/Group 512775.svg"
            alt=""
          />
          <span class="new-header">Scenario Summary</span>
        </div>
        <div class="summary-output-wrapper">
          <ng-container *ngIf="!summaryCardLoader">
            <div *ngFor="let scenario of this.summaryCardBase">
              <div class="summary-output-container">
                <div class="summary-output-header">{{ scenario.name }}</div>
                <table>
                  <tr class="summary-output-data-row">
                    <td
                      *ngFor="
                        let key of Object.keys(
                          sortObjectByValues(globalMapper.summary.base)
                        )
                      "
                    >
                      <div class="overflow-ellipsis" *ngIf="key !== 'name'">
                        {{ globalMapper.summary.base[key] + "  :   " }}
                      </div>
                      <span style="display: flex">
                        <ng-container *ngIf="key !== 'base_market_share'">
                          {{ formatNumber(scenario[key], 1) }}
                        </ng-container>

                        <ng-container *ngIf="key === 'base_market_share'">
                          {{ formatNumber(scenario[key], 2) }}
                        </ng-container>
                        <span *ngIf="key === 'base_market_share'">{{
                          "&nbsp;%"
                        }}</span>
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="summary-output-wrapper">
              <div
                class="summary-output"
                *ngFor="let scenario of summaryCardsData"
              >
                <div class="summary-output-container">
                  <div class="summary-output-header">{{ scenario.name }}</div>
                  <table>
                    <tr class="summary-output-data-row">
                      <td *ngFor="let key of getSortedKeys(scenario)">
                        <div class="overflow-ellipsis">
                          {{ globalMapper.summary.child[key] + ":" }}
                        </div>
                        <span class="summary-output-data">
                          <span *ngIf="key === 'share'">
                            {{ formatNumber(scenario[key].baseData, 2) }}
                            {{ "%" }}</span
                          >
                          <span *ngIf="key !== 'share'">
                            {{ formatNumber(scenario[key].baseData, 1) }}</span
                          >
                          <span
                            *ngIf="selectedView !== 'Percent'"
                            [ngClass]="{
                              'text-green': scenario[key].absChange >= 0,
                              'text-red': scenario[key].absChange < 0
                            }"
                          >
                            <ng-container *ngIf="key === 'share'">
                              {{
                                "  (" + formatNumber(scenario[key].absChange, 2)
                              }}
                            </ng-container>

                            <ng-container *ngIf="key !== 'share'">
                              {{
                                "  (" + formatNumber(scenario[key].absChange, 1)
                              }}
                            </ng-container>

                            <span *ngIf="key === 'share'">{{ "%" }}</span>
                            {{ ")" }}
                          </span>

                          <span
                            *ngIf="selectedView === 'Percent'"
                            [ngClass]="{
                              'text-green': scenario[key].percentChange >= 0,
                              'text-red': scenario[key].percentChange < 0
                            }"
                          >
                            <ng-container *ngIf="key === 'share'">
                              {{
                                "  ( " +
                                  formatNumber(scenario[key].percentChange, 2) +
                                  " % )"
                              }}
                            </ng-container>

                            <ng-container *ngIf="key !== 'share'">
                              {{
                                "  ( " +
                                  formatNumber(scenario[key].percentChange, 1) +
                                  " % )"
                              }}
                            </ng-container>
                          </span>
                        </span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </ng-container>

          <mat-card
            *ngIf="summaryCardLoader"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              height: 375px;
              margin-left: auto;
              margin-right: auto;
            "
            class="mat-elevation-z0"
          >
            <mat-progress-spinner
              diameter="70"
              color="primary"
              mode="indeterminate"
            >
            </mat-progress-spinner>
            <h4 style="font-weight: bold; margin-top: 10px">Loading...</h4>
          </mat-card>
        </div>
      </div>
    </div>

    <div
      class="common-chart base-value-and-transaction-chart"
      style="margin-bottom: 40px"
    >
      <div
        class="header"
        style="
          display: flex;
          justify-content: space-between;
          align-items: baseline;
        "
      >
        <div style="display: flex; align-items: center">
          <img
            src="../../../assets/IMP PVP Tool Icons/Group 512775.svg"
            alt=""
          />
          <span class="new-header">Volume By Pricing </span>
        </div>

        <div style="display: flex; justify-content: flex-end; gap: 0.5rem">
          <div class="common-drop">
            <div class="key">KPI's :</div>
            <mat-form-field appearance="outline">
              <mat-select
                name="countryString"
                [(value)]="selectedKPI"
                placeholder=""
                [disabled]="tableDataLoader"
                (selectionChange)="getTableData()"
              >
                <mat-option
                  *ngFor="let option of kpiOptions"
                  [value]="option"
                  >{{ option }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>

          <div class="common-drop">
            <div class="key">View By :</div>
            <mat-form-field appearance="outline">
              <mat-select
                name="countryString"
                [(value)]="selectedViewBy"
                placeholder=""
                (selectionChange)="getTableData()"
                [disabled]="tableDataLoader"
              >
                <mat-option
                  *ngFor="let option of viewByOptions"
                  [value]="option"
                  >{{
                    baseDetails["price"] === "Post Code Plan" &&
                    option === "Retailer"
                      ? "Region Leader"
                      : option === "Brand Variant"
                        ? "Sub Brand"
                        : option === "Brand Pack Variant"
                          ? "SKU Description"
                          : option
                  }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <button
              class="round-corners"
              mat-raised-button
              [matMenuTriggerFor]="menu"
              color="primary"
            >
              <span> Download Excel </span>
            </button>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>

      <div class="table-container">
        <table
          *ngIf="!tableDataLoader"
          mat-table
          [dataSource]="dataSourceTable"
          class="mat-table"
        >
          <!-- Dynamic column generation using *ngFor -->
          <ng-container
            *ngFor="let column of dataSourceColumns"
            [matColumnDef]="column"
          >
            <th mat-header-cell *matHeaderCellDef class="sticky-column">
              <ng-container *ngIf="column === 'scenarioName'">
                {{ selectedViewBy }}
              </ng-container>
              <ng-container *ngIf="column != 'scenarioName'">
                <div
                  *ngIf="
                    baseDetails['price'] == priceChangeMapper.POST_CODE_PLAN &&
                      column === retailer;
                    else otherThanRetailer
                  "
                >
                  {{ regionLeader }}
                </div>
                <ng-template #otherThanRetailer>
                  {{
                    column === "Brand Variant"
                      ? "Sub Brand"
                      : column === "Brand Pack Variant"
                        ? "SKU Description"
                        : column
                  }}
                </ng-template>
              </ng-container>
            </th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="column === 'scenarioName'">
                {{ element[column] }}
              </ng-container>
              <ng-container *ngIf="column != 'scenarioName'">
                {{ element[column] }}
              </ng-container>
            </td>
          </ng-container>

          <!-- Debug section to display raw data -->
          <tr mat-row *matRowDef="let row; columns: dataSourceColumns">
            <td>{{ row | json }}</td>
          </tr>

          <!-- Header definition -->
          <tr mat-header-row *matHeaderRowDef="dataSourceColumns"></tr>
        </table>
      </div>

      <mat-card
        *ngIf="tableDataLoader"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          margin-left: auto;
          margin-right: auto;
          height: 250px;
        "
        class="mat-elevation-z0"
      >
        <mat-progress-spinner
          diameter="70"
          color="primary"
          mode="indeterminate"
        >
        </mat-progress-spinner>
        <h4 style="font-weight: bold; margin-top: 10px">Loading...</h4>
      </mat-card>
      <mat-paginator
        [hidden]="!dataSourceTable.data.length"
        [pageSizeOptions]="[10]"
      ></mat-paginator>
    </div>

    <div class="controls" style="margin-bottom: 15px">
      <div class="control-buttons" style="display: flex">
        <!-- <button mat-button
        raised
        (click)="goBack()"
        >
          <mat-icon style="color:#e61a27;font-size: 20px;">arrow_back</mat-icon>
          Go Back</button> -->
        <mat-icon style="color: #e61a27; font-size: 20px">arrow_back</mat-icon>
        <span style="color: #e61a27; cursor: pointer" (click)="exit()">
          Exit</span
        >
      </div>
      <div class="view-toggle"></div>
    </div>
  </div>
</div>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="downloadCSV()">Download View</button>
  <button mat-menu-item (click)="downloadExcelFile()">
    Download Full Data
  </button>
</mat-menu>
